import React from 'react';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';
import FormSection from '@reverbdotcom/commons/src/components/form_section';
import I18n from 'i18n-js';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../components/shared/url_helpers';
import InformActVerificationForType from './inform_act_verification_for_type';

export const HELP_CENTER_ARTICLE_ID = '22671226454675';

function InformActVerifications() {
  const BANK_ACCOUNT_TYPE = 'bankAccount';
  const TAX_ID_TYPE = 'taxId';

  const hasValidTaxId:boolean = false;
  const taxIdUpdatedDate:any = null;

  const hasValidBankAccount:boolean = true;
  const bankAccountUpdatedDate:any = '2023-11-01';

  const isInformActVerificationEnabled:boolean = useExpEnabled(experiments.INFORM_ACT_SELLER_VERIFICATION);

  if (!isInformActVerificationEnabled) return null;

  return (
    <FormSection
      description={
        <Translate text="discovery.informActVerifications.description">
          <CoreLink
            className="text-link"
            target="_blank"
            to={Paths.helpCenterArticlesUrl.expand({ articleId: HELP_CENTER_ARTICLE_ID })}
          >
            <Translate text="discovery.informActVerifications.learnMore" />
          </CoreLink>
        </Translate>
      }
      title={I18n.t('discovery.informActVerifications.title')}
    >
      <div className="verification-task-list">
        <div className="verification-task-list__items">
          <InformActVerificationForType
            verificationType={TAX_ID_TYPE}
            isVerified={hasValidTaxId}
            updatedDate={taxIdUpdatedDate}
          />
          <InformActVerificationForType
            verificationType={BANK_ACCOUNT_TYPE}
            isVerified={hasValidBankAccount}
            updatedDate={bankAccountUpdatedDate}
          />
        </div>
      </div>
    </FormSection>
  );
}

export default InformActVerifications;
